import { create } from 'zustand';

type Config = {
    SERVER_URL: string;
    AUTH_URL_BASE: string;
    AUTH_PROFILE_URL: string;
    AUTH_CALLBACK_URL: string;
    GOOGLE_CLIENT_ID: string;
    featureFlag: boolean;
};

type ConfigState = {
    config: Config | null;
    setConfig: (config: Config) => void;
    loadConfig: () => Promise<void>;
};

export const useConfigStore = create<ConfigState>((set) => ({
    config: null,


    setConfig: (config) => set({ config }),

    loadConfig: async () => {
        try {
            const SERVER_URL = "https://apis.zidbit.com";
            // const SERVER_URL = "http://localhost:8081"; // For local testing

            const res = await fetch(`${SERVER_URL}/config.json`);
            if (!res.ok) throw new Error('Failed to load config');
            const data = await res.json();
            set({ config: data });
        } catch (err) {
            console.error('Error loading config:', err);
        }
    },
}));
